import { render, staticRenderFns } from "./CenterOrder.vue?vue&type=template&id=7cbe8259&"
import script from "./CenterOrder.vue?vue&type=script&lang=js&"
export * from "./CenterOrder.vue?vue&type=script&lang=js&"
import style0 from "./CenterOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports